module.exports = __webpack_public_path__ + "media/images/fonts/Feather-3dc6619f9f7fa059db35af72fefeba53.svg";